import { ButtonSpinner } from "@/components/ButtonSpinner";
import { TicketAllocationDropdown } from "@/components/portal/accreditation/TicketAllocationDropdown";
import { Input } from "@/crud/form/Input";
import { Switch } from "@/crud/form/Switch";
import { useDarkMode } from "@/hooks";
import { AccreditationGroup } from "@/models/accreditation";
import { useAccreditationStore } from "@/store/accreditation";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { useFormik, useFormikContext } from "formik";
import { TicketIcon } from "lucide-react";
import { QueryClient } from "react-query";

interface Props {
  group: AccreditationGroup;
  isSubmitting: boolean;
}
export const RequestPaymentDetails = ({ group, isSubmitting }: Props) => {
  const { values, handleSubmit } = useFormikContext();
  const { requestPaymentIndividual } = useAccreditationStore();
  const ticketCount = group.groupAllocatedTickets.reduce((acc, ticket) => {
    acc[ticket.ticket.id] = ticket.claimed;
    return acc;
  }, {});
  const darkMode = useDarkMode();

  return (
    <div className="mx-1 flex">
      {group.groupAllocatedTickets.length == 0 ? (
        <span className="inline-flex items-center rounded-md bg-yellow-400/10 px-2 py-1 text-xs font-medium text-yellow-500 ring-1 ring-inset ring-yellow-400/20">
          <ExclamationTriangleIcon
            aria-hidden="true"
            className="size-4 text-yellow-400 mr-1.5"
          />
          This group has no tickets allocated to it yet. Allocated some first to
          allow users to auto-assign tickets.
        </span>
      ) : (
        <>
          <div className="w-1/2 pr-6">
            <h4 className="dark:text-zinc-500 font-medium text-sm">Tickets</h4>
            <div className="mt-2">
              <TicketAllocationDropdown
                name="tickets"
                tickets={group.groupAllocatedTickets}
                ticketCount={ticketCount}
              />
            </div>

            {values.tickets && values.tickets.length > 0 && (
              <>
                <div className="flex mt-4">
                  <div className="flex grow flex-col">
                    <span className="text-sm/6 font-medium text-gray-900 dark:text-white">
                      Only send receipt
                    </span>
                    <span className="text-xs text-gray-500">
                      If you manage access elsewhere, we can just send a receipt
                      of payment instead of a ticket
                    </span>
                  </div>
                  <div className="flex-1">
                    <Switch name="onlySendReceipt" />
                  </div>
                </div>

                <div className="flex mt-4">
                  <div className="flex grow flex-col">
                    <span className="text-sm/6 font-medium text-gray-900 dark:text-white">
                      Bond (300 remaining)
                    </span>
                    <span className="text-xs text-gray-500">
                      We will communicate the payment as a refundable bond and
                      allow you to approve/decline the refund after the bond has
                      been paid. Plus, fees will be included/the bond will go
                      against your allowance.
                    </span>
                  </div>
                  <div className="flex-1">
                    <Switch name="isBond" />
                  </div>
                </div>
              </>
            )}

            <button
              type="button"
              onClick={() => handleSubmit()}
              className="rounded-md dark:bg-white/10 bg-black hover:bg-black/75 px-3 py-2 text-sm font-semibold text-white shadow-sm dark:hover:bg-white/20 flex items-center mt-4 w-full flex justify-center"
            >
              {isSubmitting ? (
                <ButtonSpinner colour={darkMode ? "white" : "black"} />
              ) : (
                "Create payment link"
              )}
            </button>
          </div>
          {values.tickets && values.tickets.length > 0 && (
            <div className="w-1/2 border-l pl-6 dark:border-white/5">
              {values?.tickets?.map((ticket: any) => (
                <div className="mb-2 rounded-md flex text-zinc-500 text-sm">
                  {/* <div className="mr-2 inline-flex items-center rounded-md bg-gray-400/10 px-2 py-1 text-xs font-medium text-gray-400 ring-1 ring-inset ring-gray-400/20">
              <TicketIcon className="h-4 w-4" />
            </div> */}
                  <h4 className="">{ticket.value}</h4>
                  <div className="flex-1 justify-end flex">
                    <p>&euro;300.00</p>
                  </div>
                </div>
              ))}
              <div className="text-sm border-t dark:border-white/10 pt-2 mt-3">
                <div className="flex dark:text-zinc-500">
                  <h4 className="">Fees</h4>
                  <p className="flex-1 flex justify-end">&euro;9.00</p>
                </div>
                {/* <div className="flex mt-2 dark:text-white">
              <h4 className="">Override total</h4>
              <div className="flex-1 flex justify-end">
                <Switch name="overrideTotal" />
              </div>
            </div> */}
                <div className="flex mt-2 dark:text-white">
                  <h4 className="">Total to individual</h4>
                  <div className="flex-1 flex justify-end">
                    <p>&euro;300.00</p>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};
